/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { TableView } from "@src/app/model/sys/nav-item";
import { SchedulePageComponent } from "@src/app/modules/budget/schedule-page/schedule-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const SchedulePageNavRoute = new NavRoute('budgets/schedules', ()=>SchedulePageComponent, 'pie_chart').setViews(() => {
    return [
        {
            id: 'active',
            name: 'Active Schedules',
            helpText: 'Schedules currently in use',
            filterFields: {
            },
        },
        { id: 'archived', name: 'Archived Schedules',
            helpText: 'Schedules that have been archived',
            filterFields: {
                isCurrent: false,
            }
        }
    ] as TableView[]
});
